/*
 * back-to-top.js — botón flotante "Volver arriba".
 * Aparece tras bajar cierto umbral y hace scroll suave al inicio.
 */
if (!customElements.get('back-to-top')) {
  customElements.define(
    'back-to-top',
    class BackToTop extends HTMLElement {
      constructor() {
        super();
        this.button = this.querySelector('.back-to-top__btn');
        this.threshold = 400;
        this.onScroll = this.onScroll.bind(this);
      }

      connectedCallback() {
        if (this.button) {
          this.button.addEventListener('click', () => {
            const reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
            window.scrollTo({ top: 0, behavior: reduce ? 'auto' : 'smooth' });
          });
        }
        window.addEventListener('scroll', this.onScroll, { passive: true });
        this.onScroll();
      }

      disconnectedCallback() {
        window.removeEventListener('scroll', this.onScroll);
      }

      onScroll() {
        this.classList.toggle('is-visible', window.scrollY > this.threshold);
      }
    }
  );
}
